import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { AdminNavEntryPoint, AdminNavEntryPointV2 } from '@retailer-platform/dashboard/routing'
import { storefrontShortcutsBarAdminRouter } from './routing/storefrontShortcutsBarRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import { storefrontShortcutsBarAccessControl } from './access-control/storefrontShortcutsBarAccess.configuration'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'storefront-shortcuts-bar',
  totem: {
    tool: 'shortcuts-bar-dashboard-tool',
  },
  routes,
  translations: { EN_US },
  routers: {
    admin: [storefrontShortcutsBarAdminRouter],
  },
  adminNavigationEntries: [
    {
      attachTo: AdminNavEntryPoint.Merchandising,
      attachToV2: AdminNavEntryPointV2.Merchandising,
      subNavItems: [
        {
          route: 'app-admin-storefront-shortcuts-bar',
          labelId: 'storefrontShortcutsBarDomain.title',
          accessControl: storefrontShortcutsBarAccessControl,
        },
      ],
    },
  ],
  navigationEntries: [],
}

export default definition
